<template>
  <i class="fa fa-fw fa-th-list fa-survey"></i>
</template>

<script>
export default {
  name: 'SurveyIcon',
};
</script>
<style scoped>
.fa-survey {
  color: #cccf29;
}
</style>



// WEBPACK FOOTER //
// SurveyIcon.vue?24f733e0